import BeneficiarioInfo from './BeneficiarioInfo';

export default BeneficiarioInfo;
